import axios from 'axios';
import { notification } from 'antd';

// A path starting with '/' is resolved against REACT_APP_API_URL; full URLs pass through unchanged.
export const useFetch = async (url, params = {}) => {
  try {
    const header = {
      headers: { Authorization: localStorage.getItem('token') },
    };

    const target = url.startsWith('/') ? `${process.env.REACT_APP_API_URL}${url}` : url;
    const data = await axios.get(target, { params, headers: header.headers });
    return data.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      notification.error({
        message: 'Unauthorized, please relogin to proceed',
      });
      localStorage.clear();
      window.location.reload();
    }
    throw error;
  }
};
